import 'react-multi-carousel/lib/styles.css';

import { Box, Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Carousel from 'react-multi-carousel';

export default function SponsorList({ sponsors }) {
  const { t } = useTranslation();

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <Paper elevation={2} sx={{ marginTop: 2 }}>
      <Typography variant="h2" textAlign="center" sx={{ py: 2 }} className="font-bebas">
        {t('sponsors.title')}
      </Typography>
      <Carousel
        autoPlay
        infinite
        swipeable
        responsive={responsive}
        autoPlaySpeed={3000}
        arrows={false}
      >
        {sponsors.map(sponsor => (
          <Paper
            key={sponsor.id}
            elevation={3}
            className="carousel-item"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              padding: 4,
            }}
          >
            {sponsor.logo && (
              <Box
                component="img"
                src={`data:image/png;base64,${sponsor.logo}`}
                alt={`${sponsor.name} logo`}
                className="sponsor-logo"
              />
            )}
          </Paper>
        ))}
      </Carousel>
    </Paper>
  );
}

SponsorList.propTypes = {
  sponsors: PropTypes.arrayOf(PropTypes.object).isRequired,
};
